import * as types from './actionTypes';  
import revenueListApi from '../api/revenueListApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function fetchRevenueList(request) {

  return {
    type: types.FETCH_REVENUE_LIST,
    request
  };
}

export function fetchRevenueListRes(data) {  
  return {
    type: types.FETCH_REVENUE_LIST_RES, 
    data
  };
}

export function getRevenueList(request) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      revenueListApi.fetchRevenueList(request).then(data => {
        dispatch(fetchRevenueListRes(data));
        dispatch(fetchRevenueListRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}